/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetNewsList200ResponseDataArticlesInnerThumbnailInner } from './GetNewsList200ResponseDataArticlesInnerThumbnailInner'
import {
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSON,
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSONTyped,
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerToJSON,
} from './GetNewsList200ResponseDataArticlesInnerThumbnailInner'

/**
 *
 * @export
 * @interface GetNewsList200ResponseDataArticlesInner
 */
export interface GetNewsList200ResponseDataArticlesInner {
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  category?: string | null
  /**
   *
   * @type {Date}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  publishedAt?: Date | null
  /**
   * Время чтения, например «5 минут»
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  readingTime?: string | null
  /**
   * Конверсии обложки (оригинал + pc/tablet/mobile, по убыванию площади)
   * @type {Array<GetNewsList200ResponseDataArticlesInnerThumbnailInner>}
   * @memberof GetNewsList200ResponseDataArticlesInner
   */
  thumbnail?: Array<GetNewsList200ResponseDataArticlesInnerThumbnailInner>
}

/**
 * Check if a given object implements the GetNewsList200ResponseDataArticlesInner interface.
 */
export function instanceOfGetNewsList200ResponseDataArticlesInner(
  value: object
): value is GetNewsList200ResponseDataArticlesInner {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  return true
}

export function GetNewsList200ResponseDataArticlesInnerFromJSON(
  json: any
): GetNewsList200ResponseDataArticlesInner {
  return GetNewsList200ResponseDataArticlesInnerFromJSONTyped(json, false)
}

export function GetNewsList200ResponseDataArticlesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200ResponseDataArticlesInner {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    category: json['category'] == null ? undefined : json['category'],
    publishedAt:
      json['publishedAt'] == null ? undefined : new Date(json['publishedAt']),
    readingTime: json['readingTime'] == null ? undefined : json['readingTime'],
    thumbnail:
      json['thumbnail'] == null
        ? undefined
        : (json['thumbnail'] as Array<any>).map(
            GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSON
          ),
  }
}

export function GetNewsList200ResponseDataArticlesInnerToJSON(
  value?: GetNewsList200ResponseDataArticlesInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    category: value['category'],
    publishedAt:
      value['publishedAt'] == null
        ? undefined
        : (value['publishedAt'] as any).toISOString(),
    readingTime: value['readingTime'],
    thumbnail:
      value['thumbnail'] == null
        ? undefined
        : (value['thumbnail'] as Array<any>).map(
            GetNewsList200ResponseDataArticlesInnerThumbnailInnerToJSON
          ),
  }
}
